//@ts-ignore
import { tw } from "@careinfo/tailwind";

export default function Skeleton() {
  return (
    <>
      <div
        className={tw`w-full bg-gray-200 rounded-md h-24 mb-8 animate-pulse`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      ></div>
      <div className={tw`grid grid-cols-4 gap-x-6  `}>
        {Array.from({ length: 8 }).map((_, index) => {
          return (
            <div
              key={index}
              className={tw`w-full bg-gray-200 rounded-md h-20  mb-8 animate-pulse`}
              style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
            ></div>
          );
        })}
      </div>
      <div
        className={tw`w-full bg-white rounded-sm mb-8`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <div
          className={tw`w-full grid grid-cols-1 gap-4 md:flex justify-between items-center p-4`}
        >
          <div
            className={tw`mr-2 h-8 w-48 rounded-md animate-pulse focus:outline-none animate-pulse bg-gray-200`}
          ></div>
          <div
            className={tw`"text-primary w-full justify-end items-center flex gap-4 space-x-4"`}
          >
            <span
              className={tw`flex gap-x-1 w-full cursor-pointer w-24 h-8 rounded-md bg-gray-200 animate-pulse`}
            ></span>
            <span
              className={tw`flex gap-x-1 w-full cursor-pointer w-24 h-8 bg-gray-200 rounded-md animate-pulse`}
            ></span>
            <span
              className={tw`flex gap-x-1 w-full cursor-pointer w-24 h-8 bg-gray-200 rounded-md animate-pulse`}
            ></span>
          </div>
        </div>
        <div className={tw`w-full overflow-auto z-0`}>
          <div className={tw`w-full h-[400px]`}>
            <div
              className={tw`h-10 bg-primary flex items-center gap-x-1 justify-between text-white uppercase animate-pulse`}
            >
              {Array.from({ length: 7 }).map((_, index) => {
                return (
                  <div
                    key={index}
                    className={tw`h-8 w-full rounded-xl animate-pulse`}
                  ></div>
                );
              })}
            </div>
            <div className={tw`grid grid-cols-7  gap-y-1 mt-1`}>
              {Array.from({ length: 70 }).map((_, index) => {
                return (
                  <div
                    key={index}
                    className={tw`h-10 animate-pulse  bg-gray-200`}
                  ></div>
                );
              })}
            </div>
          </div>
        </div>
        <div
          className={tw`flex bg-white py-2 my-4 w-full justify-center gap-4`}
        >
          <button className={tw`border hidden md:block rounded p-1`} disabled>
            {"<<"}
          </button>
          <button className={tw`border rounded p-1`} disabled>
            {"<"}
          </button>
          <button className={tw`border rounded p-1`} disabled>
            {">"}
          </button>
          <button className={tw`border hidden md:block rounded p-1`} disabled>
            {">>"}
          </button>
          <span className={tw`flex items-center gap-1`}>
            <div>Page</div>
            <strong className={tw`flex items-center gap-1`}>
              <span
                className={tw`inline-block animate-pulse h-4 w-8 bg-gray-200 rounded-md`}
              ></span>
              of
              <span
                className={tw`inline-block animate-pulse h-4 w-8 bg-gray-200 rounded-md`}
              ></span>
            </strong>
          </span>
          {/* <span className="flex items-center gap-1">
              | Go to page:
              <input
                type="number"
                min={1}
                value={page}
                max={Math.ceil(serverData?.count/limit)}
                onChange={e => {setPage(Number(e.target.value))}}
                className="border p-1 rounded w-16"
              />
            </span> */}
          <p className={tw`flex items-center gap-1 mt-1`}>
            <span>All:</span>
            <span
              className={tw`inline-block animate-pulse h-4 w-8 bg-gray-200 rounded-md`}
            ></span>
          </p>
        </div>
      </div>
    </>
  );
}
